<template>
  <div>
    <page-title title="Content" />
    <b-row>
      <b-col>
        <filtered-table :settings="tableSettings">
        </filtered-table>
      </b-col>
    </b-row>
  </div>
</template>

<script>
export default {
  name: "ContentBlockList",
  props: {},
  data() {
    let base = this;
    return {
      tableSettings: {
        query: 'contentBlocks',
        newUrl: '/contentBlock/add',
        columns: [
          {
            key: 'id',
            name: 'ID',
            alwaysLoad: true,
            visible: false,
            sortable: true,
            filter: 'text'
          },
          {
            key: 'name',
            name: 'Name',
            visible: true,
            sortable: true,
            filter: 'text'
          },
          {
            key: 'slug',
            name: 'Slug',
            visible: true,
            sortable: true,
            filter: 'text'
          },
          {
            key: 'title',
            name: 'Title',
            visible: true,
            sortable: true,
            filter: 'text'
          },
          {
            key: 'description',
            name: 'Description',
            visible: true,
            sortable: true,
            filter: 'text'
          }
        ],
        getDefaultFilter: function () {
          return '';
        },
        rowClicked: function (item, context) {
          context.$router.push('/contentBlock/' + item.id + '/edit');
        }
      }
    }
  },
  methods: {
  },
  mounted () {
  }
};
</script>